import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useFirstTimeUser } from '../hooks/useFirstTimeUser';
import VideoPopup from './VideoPopup';
import { VIDEO_CONFIG } from '../constants/video-config';

const VideoPopupManager = () => {
    const { user, loading } = useAuth();
    const { isFirstTime, markVideoAsSeen, isLoading: isFirstTimeLoading } = useFirstTimeUser();
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        // Only show popup if:
        // 1. User is authenticated
        // 2. Not loading
        // 3. Is first time user
        // 4. First time check is complete
        if (user && !loading && !isFirstTimeLoading && isFirstTime) {
            // Add a delay before showing the popup
            const timer = setTimeout(() => {
                setShowPopup(true);
            }, VIDEO_CONFIG.POPUP_DELAY_MS);

            return () => clearTimeout(timer);
        }
    }, [user, loading, isFirstTime, isFirstTimeLoading]);

    const handleClose = () => {
        setShowPopup(false);
    };

    const handleVideoSeen = () => {
        markVideoAsSeen();
    };

    // Don't render anything if still loading or no user
    if (loading || isFirstTimeLoading || !user) {
        return null;
    }

    return (
        <VideoPopup
            isOpen={showPopup}
            onClose={handleClose}
            onVideoSeen={handleVideoSeen}
        />
    );
};

export default VideoPopupManager; 